document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector("#load-more");
  const root = document.querySelector("[data-collection-groups]");
  if (!btn || !root) return;

  let currentPage = parseInt(btn.dataset.page || "1", 10);
  let isLoading = false;

  async function fetchNextPage(page) {
    const res = await fetch(`${btn.dataset.base}?sections=${btn.dataset.sectionType}&page=${page}`);
    const json = await res.json();
    const html = json[btn.dataset.sectionType];
    const doc = new DOMParser().parseFromString(html, "text/html");
    return Array.from(doc.querySelectorAll("li[data-sub]"));
  }

  function groupItemsBySub(items) {
    const groups = {};
    items.forEach(li => {
      const sub = li.dataset.sub || "lainnya";
      if (!groups[sub]) groups[sub] = [];
      groups[sub].push(li);
    });
    return groups;
  }

  btn.addEventListener("click", async () => {
    if (isLoading) return;
    isLoading = true;
    btn.disabled = true;
    btn.textContent = "Memuat...";

    const nextPage = currentPage + 1;
    const items = await fetchNextPage(nextPage);

    if (!items.length) {
      btn.remove();
      return;
    }

    const groups = groupItemsBySub(items);
    const existingGroups = Array.from(root.querySelectorAll("section.group"));
    let appended = false;

    // cari grup terakhir yang belum habis
    for (const section of existingGroups) {
      const sub = section.dataset.sub;
      const ul = section.querySelector("ul");

      if (groups[sub] && groups[sub].length > 0) {
        groups[sub].forEach(li => ul.appendChild(li));
        delete groups[sub];
        appended = true;
        break; // tampilkan satu grup penuh dulu
      }
    }

    // kalau grup di halaman baru ada subkategori baru, tambahkan ke bawah
    for (const sub in groups) {
      const section = document.createElement("section");
      section.className = "group";
      section.dataset.sub = sub;
      section.innerHTML = `
        <h2 class="subkategori-title">${sub.replace(/-/g, " ")}</h2>
        <ul class="product-grid" data-group="${sub}"></ul>
      `;
      groups[sub].forEach(li => section.querySelector("ul").appendChild(li));
      root.appendChild(section);
      appended = true;
    }

    if (!appended) {
      btn.remove();
    } else {
      currentPage++;
      btn.textContent = "Tampilkan lebih banyak";
      btn.disabled = false;
      isLoading = false;
    }
  });
});
